<template>
  <div class="pb-3" >
    <va-card :title="$t(`users.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="user.name"
                  :label="$t('users.forms.nameLabel')"
                  :placeholder="$t('users.forms.namePlaceholder')"
                  :success="errors.length == 0 && user.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }">
                <va-input
                  type='email'
                  v-model="user.email"
                  :label="$t('users.forms.emailLabel')"
                  :placeholder="$t('users.forms.emailPlaceholder')"
                  :success="errors.length == 0 && user.email.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="min:6|confirmed:user.confirmPassword" name="Senha" v-slot="{ errors }">
                <va-input
                  v-model="user.password"
                  type="password"
                  :label="$t('users.forms.passwordLabel')"
                  :placeholder="$t('users.forms.passwordPlaceholder')"
                  :success="errors.length == 0 && user.password.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider vid="user.confirmPassword" name="Confirme a Senha">
                <va-input
                  v-model="user.confirmPassword"
                  type="password"
                  :label="$t('users.forms.confirmPasswordLabel')"
                  :placeholder="$t('users.forms.confirmPasswordPlaceholder')"
                  :success="user.confirmPassword.length > 0"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Tipo" v-slot="{ errors }">
                <p class="display-5 pb-1">{{$t('users.forms.rolePlaceholder')}}</p>
                <va-radio-button
                  v-for="(role, idx) in roles" :key="idx"
                  :option="role.id"
                  :label="$t(`roles.${role.name}`)"
                  v-model="user.role_id"
                />
                <div
                  v-if="errors.length"
                  class="va-message-list"
                  :style="colorComputed"
                >
                  <div
                    class="va-message-list__message"
                    v-for="(message, index) in errors"
                    :key="index"
                  >
                    {{message}}
                  </div>
                </div>
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'UserAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        role_id: 1,
      },
      roles: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    roles: {
      query: gql`
        query MyQuery {
          roles: role {
            id
            name
          }
        }
        `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.roles.length > 0) {
            this.role = data.roles[0]
          }
        }
      },
    },
  },
  mounted () {
    this.user.name = ''
    this.user.email = ''
    this.user.password = ''
    this.user.confirmPassword = ''
    this.user.role_id = ''
    if (this.updateData !== null) {
      this.user_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.user_get(this.updateData)
      } else {
        this.user.name = ''
        this.user.email = ''
        this.user.password = ''
        this.user.confirmPassword = ''
        this.user.role_id = 1
      }
    },
  },
  methods: {
    submit () {
      if (this.updateData != null) {
        this.onUpdate()
      } else {
        this.onSubmit()
      }
    },
    cancel () {
      this.$emit('showAdd', false)
    },
    user_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== 'role' && value !== '__typename') {
          this.user[value] = data[value]
        } else if (value === 'role') {
          this.role = data.role
          this.user.role_id = data.role.id
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      // eslint-disable-next-line camelcase
      const { name, email, password, confirmPassword, role_id } = this.user
      const self = this
      this.$axios.post(
        '/api/user/add',
        {
          name,
          email,
          password,
          confirmPassword,
          role_id,
        },
      )
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.user.name = ''
          self.user.email = ''
          self.user.password = ''
          self.user.confirmPassword = ''
          self.user.role_id = 1
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t('toasts.successCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.user.name = ''
          self.user.email = ''
          self.user.password = ''
          self.user.confirmPassword = ''
          self.user.role_id = 1
          self.$emit('showAdd', false)
          self.showToast(
            self.$t('toasts.errorCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    onUpdate () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      // eslint-disable-next-line camelcase
      const { name, email, password, confirmPassword, role_id } = this.user
      const self = this
      this.$axios.put(
        `/api/user/${this.user.id}`,
        password
          ? {
            name,
            email,
            password,
            confirmPassword,
            role_id,
            id: this.user.id,
          } : {
            name,
            email,
            role_id,
            id: this.user.id,
          },
      )
        .then(response => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.user.name = ''
          self.user.email = ''
          self.user.password = ''
          self.user.confirmPassword = ''
          self.user.role_id = 1
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.user.name = ''
          self.user.email = ''
          self.user.password = ''
          self.user.confirmPassword = ''
          self.user.role_id = 1
          self.$emit('showAdd', false)
          self.showToast(
            self.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
</style>
